import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { area, line } from 'd3-shape';
import * as R from 'remeda';

export interface Series {
  name: Date;
  value: number;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'g[sa-lmo-current-stock-graph-custom-line]', // tslint:disable-line
  template: `
    <svg:g>
      <svg:g
        ngx-charts-line
        class="line-series"
        [data]="data"
        [path]="path"
        [stroke]="stroke"
        [animations]="animations"
      />
      <svg:g
        ngx-charts-area
        class="area-series"
        [data]="data"
        [path]="areaPath"
        [fill]="stroke"
        [startingPath]="areaStartingPath"
        [opacity]="opacity"
        [gradient]="false"
        [animations]="animations"
      />
    </svg:g>
  `,
})
export class LmoCurrentStockGraphCustomLineComponent implements OnChanges {
  @Input() public data;
  @Input() public xScale;
  @Input() public yScale;
  @Input() public colors;
  @Input() public curve: any;
  @Input() public activeEntries: any[];
  @Input() public animations = true;

  public path: string;
  public areaStartingPath: string;
  public areaPath: string;
  public stroke: any;
  public opacity = 0.2;

  public ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  private update(): void {
    const data = this.sortData(this.data.series);

    const lineGen = this.getLineGenerator();
    this.path = lineGen(data) || '';

    this.stroke = this.colors.getColor(this.data.name);
    this.setupArea(data);
  }

  private getLineGenerator(): any {
    return line<any>()
      .x((d: Series) => this.xScale(d.name))
      .y((d: Series) => this.yScale(d.value))
      .curve(this.curve)
      .defined(function(d: Series) {
        return d.value !== undefined && d.value !== null;
      });
  }

  private setupArea(data): any {
    let currentArea;
    let startingArea;

    const xProperty = (d) => {
      const label = d.name;
      return this.xScale(label);
    };

    currentArea = area<any>()
      .x(xProperty)
      .y0(() => this.yScale.range()[0])
      .y1((d) => this.yScale(d.value));

    startingArea = area<any>()
      .x(xProperty)
      .y0(() => this.yScale.range()[0])
      .y1(() => this.yScale.range()[0]);

    currentArea.curve(this.curve).defined(function(d: Series) {
      return d.value !== undefined && d.value !== null;
    });
    startingArea.curve(this.curve).defined(function(d: Series) {
      return d.value !== undefined && d.value !== null;
    });

    this.areaPath = currentArea(data);
    this.areaStartingPath = startingArea(data);
  }

  private sortData(data: Series[]) {
    return R.sort(data, (a, b) => {
      const aDate = a.name.getTime();
      const bDate = b.name.getTime();
      if (aDate > bDate) {
        return 1;
      }
      if (bDate > aDate) {
        return -1;
      }
      return 0;
    });
  }
}
